import { useParams, Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  const filteredArticles = slug
    ? articles.filter((a) => a.category === slug)
    : articles;

  const categoryName = category ? category.name : '全部文章';

  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: categoryName },
  ];

  return (
    <>
      <title>{`${categoryName} - 91黑料吃瓜网 | 最新吃瓜视频与独家黑料直击`}</title>
      <meta name="description" content={`91黑料吃瓜网${categoryName}频道，每日在线更新${categoryName}相关的最新吃瓜视频与深度黑料直击。覆盖网络红人、主播博主塌房现场，独家爆料抢先看。`} />
      <meta name="keywords" content={`91黑料吃瓜网, ${categoryName}, 吃瓜视频, 网红塌房, 黑料曝光, 独家爆料`} />
      <link rel="canonical" href={`https://91heiliaochigua.com/category/${slug}`} />
      <meta property="og:title" content={`${categoryName} - 91黑料吃瓜网`} />
      <meta property="og:description" content={`91黑料吃瓜网${categoryName}频道，每日在线更新最新吃瓜视频与深度黑料直击。`} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://91heiliaochigua.com/category/${slug}`} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${categoryName} - 91黑料吃瓜网`} />
      <meta name="twitter:description" content={`91黑料吃瓜网${categoryName}频道，每日在线更新最新吃瓜视频与深度黑料直击。`} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "name": `${categoryName} - 91黑料吃瓜网`,
        "url": `https://91heiliaochigua.com/category/${slug}`,
        "description": `91黑料吃瓜网${categoryName}频道`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "91黑料吃瓜网",
          "url": "https://91heiliaochigua.com"
        }
      }) }} />

      <Breadcrumb items={breadcrumbItems} />

      <section className="w-full px-4 md:px-6 pt-8 pb-4 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-2">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                {categoryName}
              </h1>
              {category && (
                <p className="text-sm text-foreground-500 mt-2">
                  {category.description}
                </p>
              )}
            </div>
            <span className="text-sm text-foreground-400 whitespace-nowrap">
              共 {filteredArticles.length} 篇文章
            </span>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-2 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 py-3 overflow-x-auto scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            <Link
              to="/category/wanghong-tafang"
              className={`px-4 py-1.5 text-sm font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                slug === 'wanghong-tafang'
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              网红塌房
            </Link>
            <Link
              to="/category/zhubo-bagua"
              className={`px-4 py-1.5 text-sm font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                slug === 'zhubo-bagua'
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              主播八卦
            </Link>
            <Link
              to="/category/mingxing-heiliao"
              className={`px-4 py-1.5 text-sm font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                slug === 'mingxing-heiliao'
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              明星黑料
            </Link>
            <Link
              to="/category/shehui-redian"
              className={`px-4 py-1.5 text-sm font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                slug === 'shehui-redian'
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              社会热点
            </Link>
            <Link
              to="/category/dujia-baoliao"
              className={`px-4 py-1.5 text-sm font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                slug === 'dujia-baoliao'
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              独家爆料
            </Link>
            <Link
              to="/category/chigua-shipin"
              className={`px-4 py-1.5 text-sm font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                slug === 'chigua-shipin'
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              吃瓜视频
            </Link>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto">
          {filteredArticles.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center text-foreground-300">
                <i className="ri-file-list-3-line text-4xl"></i>
              </div>
              <p className="text-foreground-500 text-sm">暂无相关文章</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {filteredArticles.map((article) => {
                const cat = categories.find((c) => c.slug === article.category);
                return (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group block bg-background-100 rounded-lg overflow-hidden transition-colors hover:bg-background-200/70 cursor-pointer"
                  >
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4">
                      <div className="flex items-center gap-2 mb-2 flex-wrap">
                        {article.exclusive && (
                          <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-800 rounded whitespace-nowrap">
                            独家
                          </span>
                        )}
                        {article.hot && (
                          <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded whitespace-nowrap">
                            热门
                          </span>
                        )}
                        {cat && (
                          <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">
                            {cat.name}
                          </span>
                        )}
                      </div>
                      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-3 text-xs text-foreground-400">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i>
                          {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                        </span>
                        <span>{article.date}</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
}